// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import Header from '@/components/Header.vue'
import swal from 'sweetalert'
import { userBillFactory } from '@/http/user-bill'
import { masterDataFactory } from '@/http/master-data'
import constants from '@/constants/constants'
import Utils from '@/utils/utils'
import roleAccessManager from '@/utils/role-access-manager'

import { dashboardDataFactory } from '@/http/dashboard-data'

import BarChart from '@/components/BarChart.vue'
import DoughnutChart from '@/components/DoughnutChart.vue'
import DoughnutChart2 from '@/components/DoughnutChart2.vue'
import PaymentPercentage from '@/components/PaymentPercentage.vue'
import RecentPayment from '@/components/RecentPayment.vue'
import DetailPayment from '@/components/DetailPayment.vue'

@Options({
  components: {
    Header,
    BarChart,
    PaymentPercentage,
    DoughnutChart,
    DoughnutChart2,
    RecentPayment,
    DetailPayment
  },
  data () {
    return {
      dataReady: false,
      schoolYears: [],
      classes: [],
      data_master: {
        school_years: '1',
        bill_types: '1',
        classes: '1',
        months: '1'
      },
      param: {
        school_year_id: this.$route.query.school_year || 0,
        class_id: this.$route.query.class || '',
        inactive: this.$route.query.inactive == 'true',
        published: this.$route.query.published == 'true'
      },
      search: '',
      payment_statistic: {
        paid: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        unpaid: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        paid_total: 0,
        unpaid_total: 0,
        bill_type: [],
        unpaid_bill_type: [],
        previous_statistic: {
          paid_total: 0,
          unpaid_total: 0
        }
      }
    }
  },
  watch: {
    '$route.query': {
      handler: 'loadPaymentStatistic',
      deep: true
    }
  },
  methods: {
    tableDataClass (data: any) {
      if (!data || data == undefined) return {}

      let is_paid = 1
      let duedate, deadlinedate
      let d1 = 0
      let d3 = 0
      let isSuccess; let isPending; let isDeadline = false
      data.forEach((value: any) => {
        if (value.status != constants.BILL_PAID) {
          is_paid = 0
        }
        if (is_paid == 0) {
          duedate = new Date(value.due_date)
          deadlinedate = new Date(value.deadline_date)
          if (d1 == 0 || d1 > deadlinedate.getTime()) {
            d1 = deadlinedate.getTime()
          }
          if (d3 == 0 || d3 > duedate.getTime()) {
            d3 = duedate.getTime()
          }
        }
      })
      if (is_paid == 1) {
        isSuccess = true
      } else if (is_paid == 0) {
        const datenow = new Date()
        datenow.setHours(0, 0, 0, 0)
        const d2 = datenow.getTime()
        if (d2 >= d1) {
          // overdue
          isDeadline = true
        } else if (d2 > d3 && d3 < d1) {
          // duedate
          isPending = true
        }
      }
      return {
        'bg-success-strip text-success': isSuccess,
        'bg-warning-strip text-warning': isPending,
        'bg-danger-strip text-danger': isDeadline
      }
    },
    getMonth: function (date: any) {
      if (date != '' && date != undefined) {
        const d = date.split('-')
        const month = d[2]
        return this.months[month].id
      } else {
        return ''
      }
    },
    getMonthIndex: function (date: any) {
      if (date != '' && date != undefined) {
        const d = date.split('-')
        const month = d[2]
        return month
      } else {
        return 0
      }
    },
    sum: function (total: any, num: any) {
      return total + num
    },
    setRouter: function () {
      this.$router.push({
        path: '/',
        query: {
          school_year: this.param.school_year_id,
          class: this.param.class_id,
          inactive: this.param.inactive,
          published: this.param.published,
          t: +new Date()
        }
      })
    },
    loadDataMaster: function () {
      Promise.all([
        masterDataFactory.master_datas(this.data_master)
      ]).then(results => {
        this.schoolYears = results[0].data.school_years
        this.classes = results[0].data.classes
        // this.param.class_id = this.classes[0].class_id
        this.schoolYears.forEach((school_year: any) => {
          if (school_year.status == 'Active') {
            this.param.school_year_id = school_year.school_year_id
          }
        })
        this.loadPaymentStatistic()
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    },
    loadPaymentStatistic: function () {
      return Promise.all([
        dashboardDataFactory.paymentStatistic(this.param)
      ]).then(results => {
        const datas = results[0].data
        this.payment_statistic = datas
      }).catch((e) => {
        swal('Gagal melakukan request', '', 'error')
        console.log(e)
      })
    }
  },
  computed: {
  },
  async mounted () {
    // Check role access untuk path '/'
    if (!roleAccessManager.canRead('/')) {
      swal({
        title: 'Access Denied',
        text: 'Anda tidak memiliki akses ke dashboard',
        icon: 'error'
      }).then(() => {
        this.$router.push('/loginpage')
      })
      return
    }

    await this.loadDataMaster()

    this.dataReady = true
  }
})

export default class Dashboard extends Vue { }
